import { createQueryKeys } from "@lukemorales/query-key-factory";
import z from "zod";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { pendingActionResponseSchema } from "@/domains/profile/models/schemas";

export const pendingActionsQueryOptions = createQueryKeys("pending-actions", {
  all: {
    queryKey: null,
    queryFn: () => {
      return getPendingActions();
    },
  },
});

const getPendingActions = async () => {
  const response = await privateApi.get("/pending-actions");

  return createServiceResponseSchema(z.array(pendingActionResponseSchema)).parse(response.data)
    .data;
};
